// Text Effects Utility - Konvertiert Effect-IDs zu CSS-Styles

export const getTextEffectStyles = (effectId) => {
    const effects = {
        'none': {},
        'gold-gradient': {
            background: 'linear-gradient(45deg, #FFD700 0%, #FFA500 25%, #FF8C00 50%, #FFD700 75%, #FFA500 100%)',
            backgroundSize: '300% 300%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 3s ease-in-out infinite'
        },
        'gold-luxury': {
            background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 20%, #FFA500 40%, #B8860B 60%, #FFD700 80%, #D4AF37 100%)',
            backgroundSize: '200% 200%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'luxuryShimmer 4s ease-in-out infinite'
        },
        'gold-glow': {
            color: '#FFD700',
            textShadow: '0 0 8px rgba(255, 215, 0, 0.6), 0 0 16px rgba(255, 215, 0, 0.4), 0 0 24px rgba(255, 215, 0, 0.2)',
            animation: 'goldGlow 2.5s ease-in-out infinite'
        },
        'gold-royal': {
            background: 'linear-gradient(90deg, #B8860B 0%, #DAA520 15%, #FFD700 30%, #FFA500 45%, #FFD700 60%, #DAA520 75%, #B8860B 90%, #8B7355 100%)',
            backgroundSize: '400% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'royalGoldFlow 5s linear infinite'
        },
        'gold-elegant': {
            color: '#B8860B',
            textShadow: '1px 1px 2px rgba(218, 165, 32, 0.3), 0 0 6px rgba(255, 215, 0, 0.2), 2px 2px 4px rgba(0, 0, 0, 0.1)',
            filter: 'drop-shadow(0 0 3px rgba(255, 215, 0, 0.3))'
        },
        'gold-vintage': {
            background: 'radial-gradient(ellipse at center, #FFD700 0%, #DAA520 30%, #B8860B 60%, #8B7355 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: '2px 2px 4px rgba(184, 134, 11, 0.3)'
        },
        'silver-gradient': {
            background: 'linear-gradient(45deg, #E5E7EB 0%, #9CA3AF 25%, #6B7280 50%, #E5E7EB 75%, #9CA3AF 100%)',
            backgroundSize: '300% 300%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 4s ease-in-out infinite'
        },
        'blue-glow': {
            color: '#3B82F6',
            textShadow: '0 0 6px rgba(59, 130, 246, 0.3), 0 0 12px rgba(59, 130, 246, 0.2), 0 0 18px rgba(59, 130, 246, 0.1)',
            animation: 'glowPulse 2s ease-in-out infinite'
        },
        'purple-glow': {
            color: '#8B5CF6',
            textShadow: '0 0 6px rgba(139, 92, 246, 0.3), 0 0 12px rgba(139, 92, 246, 0.2), 0 0 18px rgba(139, 92, 246, 0.1)',
            animation: 'glowPulse 2.5s ease-in-out infinite'
        },
        'elegant-shadow': {
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3), 0 0 8px rgba(0, 0, 0, 0.1)'
        },
        'deep-shadow': {
            textShadow: '4px 4px 8px rgba(0, 0, 0, 0.5), 2px 2px 4px rgba(0, 0, 0, 0.3)'
        },
        'neon-pink': {
            color: '#FF1493',
            textShadow: '0 0 4px #FF1493, 0 0 8px rgba(255, 20, 147, 0.4), 0 0 12px rgba(255, 20, 147, 0.2)',
            animation: 'glowPulse 1.8s ease-in-out infinite'
        },
        'neon-green': {
            color: '#00FF7F',
            textShadow: '0 0 4px #00FF7F, 0 0 8px rgba(0, 255, 127, 0.4), 0 0 12px rgba(0, 255, 127, 0.2)',
            animation: 'glowPulse 2.2s ease-in-out infinite'
        },
        'neon-red': {
            color: '#FF073A',
            textShadow: '0 0 6px #FF073A, 0 0 12px rgba(255, 7, 58, 0.5), 0 0 18px rgba(255, 7, 58, 0.3), 0 0 24px rgba(255, 7, 58, 0.1)',
            animation: 'neonRedPulse 2.2s ease-in-out infinite'
        },
        'neon-yellow': {
            color: '#FFFF00',
            textShadow: '0 0 6px #FFFF00, 0 0 12px rgba(255, 255, 0, 0.5), 0 0 18px rgba(255, 255, 0, 0.3), 0 0 24px rgba(255, 255, 0, 0.1)',
            animation: 'neonYellowPulse 1.8s ease-in-out infinite'
        },
        'holistic-earth': {
            background: 'linear-gradient(135deg, #8B7355 0%, #A0956B 25%, #B8A678 50%, #A0956B 75%, #8B7355 100%)',
            backgroundSize: '400% 400%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'holisticFlow 8s ease-in-out infinite',
            textShadow: '0 2px 4px rgba(139, 115, 85, 0.2)'
        },
        'holistic-sage': {
            color: '#87A96B',
            textShadow: '0 0 8px rgba(135, 169, 107, 0.3), 0 2px 6px rgba(135, 169, 107, 0.2), 0 4px 12px rgba(135, 169, 107, 0.1)',
            animation: 'sageBreath 4s ease-in-out infinite'
        },
        'holistic-crystal': {
            background: 'linear-gradient(45deg, #E6E6FA 0%, #DDA0DD 25%, #DA70D6 50%, #DDA0DD 75%, #E6E6FA 100%)',
            backgroundSize: '300% 300%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'crystalShimmer 6s ease-in-out infinite',
            filter: 'drop-shadow(0 0 4px rgba(218, 112, 214, 0.2))'
        },
        'holistic-moonlight': {
            color: '#F0F8FF',
            textShadow: '0 0 10px rgba(240, 248, 255, 0.4), 0 0 20px rgba(240, 248, 255, 0.2), 0 2px 8px rgba(135, 206, 235, 0.3)',
            animation: 'moonlightGlow 5s ease-in-out infinite'
        },
        'holistic-golden-aura': {
            background: 'radial-gradient(circle, #FFD700 0%, #FFA500 30%, #FF8C00 60%, #FFD700 100%)',
            backgroundSize: '200% 200%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'goldenAura 7s ease-in-out infinite',
            filter: 'drop-shadow(0 0 6px rgba(255, 215, 0, 0.3))'
        },
        'rainbow-gradient': {
            background: 'linear-gradient(45deg, #FF6B6B 0%, #4ECDC4 16%, #45B7D1 33%, #96CEB4 50%, #FFEAA7 66%, #FF6B6B 83%, #4ECDC4 100%)',
            backgroundSize: '400% 400%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'rainbowShift 6s ease-in-out infinite'
        },
        'fire-gradient': {
            background: 'linear-gradient(45deg, #FF4757 0%, #FF6348 20%, #FFA502 40%, #FFD700 60%, #FF4757 80%, #FF6348 100%)',
            backgroundSize: '350% 350%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'fireShift 2.5s ease-in-out infinite'
        },
        'ocean-gradient': {
            background: 'linear-gradient(45deg, #667eea 0%, #764ba2 25%, #667eea 50%, #764ba2 75%, #667eea 100%)',
            backgroundSize: '300% 300%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'oceanShift 5s ease-in-out infinite'
        },
        'romantic-red': {
            background: 'linear-gradient(45deg, #FF6B9D 0%, #C44569 25%, #FF6B9D 50%, #F8B500 75%, #FF6B9D 100%)',
            backgroundSize: '400% 400%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 8s ease-in-out infinite'
        },
        'bonusclub-blue': {
            background: 'linear-gradient(45deg, #667eea 0%, #764ba2 25%, #667eea 50%, #5a67d8 75%, #667eea 100%)',
            backgroundSize: '350% 350%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 7s ease-in-out infinite'
        },
        'sunset-gradient': {
            background: 'linear-gradient(45deg, #FF9A8B 0%, #FF6A88 25%, #FF99AC 50%, #FFA8B6 75%, #FF9A8B 100%)',
            backgroundSize: '380% 380%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 9s ease-in-out infinite'
        },
        'forest-gradient': {
            background: 'linear-gradient(45deg, #56ab2f 0%, #a8e6cf 25%, #56ab2f 50%, #7fcdcd 75%, #56ab2f 100%)',
            backgroundSize: '360% 360%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 10s ease-in-out infinite'
        },
        'royal-purple': {
            background: 'linear-gradient(45deg, #8B5A2B 0%, #6A4C93 25%, #8B5A2B 50%, #9B59B6 75%, #8B5A2B 100%)',
            backgroundSize: '340% 340%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 12s ease-in-out infinite'
        },
        'champagne-gradient': {
            background: 'linear-gradient(45deg, #F7DC6F 0%, #F4D03F 25%, #F7DC6F 50%, #F8C471 75%, #F7DC6F 100%)',
            backgroundSize: '320% 320%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 11s ease-in-out infinite'
        },
        'romantic-red': {
            background: 'linear-gradient(45deg, #FF6B9D 0%, #C44569 25%, #FF6B9D 50%, #F8B500 75%, #FF6B9D 100%)',
            backgroundSize: '400% 400%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 8s ease-in-out infinite'
        },
        'bonusclub-blue': {
            background: 'linear-gradient(45deg, #667eea 0%, #764ba2 25%, #667eea 50%, #5a67d8 75%, #667eea 100%)',
            backgroundSize: '350% 350%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 7s ease-in-out infinite'
        },
        'sunset-gradient': {
            background: 'linear-gradient(45deg, #FF9A8B 0%, #FF6A88 25%, #FF99AC 50%, #FFA8B6 75%, #FF9A8B 100%)',
            backgroundSize: '380% 380%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 9s ease-in-out infinite'
        },
        'forest-gradient': {
            background: 'linear-gradient(45deg, #56ab2f 0%, #a8e6cf 25%, #56ab2f 50%, #7fcdcd 75%, #56ab2f 100%)',
            backgroundSize: '360% 360%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 10s ease-in-out infinite'
        },
        'royal-purple': {
            background: 'linear-gradient(45deg, #8B5A2B 0%, #6A4C93 25%, #8B5A2B 50%, #9B59B6 75%, #8B5A2B 100%)',
            backgroundSize: '340% 340%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 12s ease-in-out infinite'
        },
        'champagne-gradient': {
            background: 'linear-gradient(45deg, #F7DC6F 0%, #F4D03F 25%, #F7DC6F 50%, #F8C471 75%, #F7DC6F 100%)',
            backgroundSize: '320% 320%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 11s ease-in-out infinite'
        },
        'spiritual-aura': {
            background: 'linear-gradient(45deg, #E8D5FF 0%, #B794F6 25%, #E8D5FF 50%, #D6BCFA 75%, #E8D5FF 100%)',
            backgroundSize: '380% 380%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 15s ease-in-out infinite'
        },
        'chakra-energy': {
            background: 'linear-gradient(45deg, #FF6B6B 0%, #4ECDC4 14%, #45B7D1 28%, #96CEB4 42%, #FFEAA7 56%, #DDA0DD 70%, #FF6B6B 84%, #4ECDC4 100%)',
            backgroundSize: '500% 500%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'rainbowShift 18s ease-in-out infinite'
        },
        'divine-light': {
            background: 'linear-gradient(45deg, #FFF8DC 0%, #F0E68C 20%, #FFE4B5 40%, #FFF8DC 60%, #F5DEB3 80%, #FFF8DC 100%)',
            backgroundSize: '350% 350%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'gradientShift 14s ease-in-out infinite'
        },
        'embossed': {
            color: '#f0f0f0',
            textShadow: '1px 1px 0px #ccc, 2px 2px 0px #c9c9c9, 3px 3px 0px #bbb, 4px 4px 0px #b9b9b9, 5px 5px 0px #aaa, 6px 6px 1px rgba(0,0,0,.1), 0 0 5px rgba(0,0,0,.1), 1px 1px 3px rgba(0,0,0,.3), 3px 3px 5px rgba(0,0,0,.2), 5px 5px 10px rgba(0,0,0,.25)'
        }
    };

    return effects[effectId] || {};
};
